import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { ProfileType } from '@fcom/core-api/login';
import { ExpandComponent, MenuItemWithChildren } from '@fcom/common';

import { LoyaltyNavigationService } from '../../services/loyalty-navigation.service';

@Component({
  selector: 'fin-loyalty-section-navigation',
  templateUrl: 'loyalty-section-navigation.component.html',
  styleUrls: ['loyalty-section-navigation.component.scss'],
})
export class LoyaltySectionNavigationComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  mobile = false;

  @Input()
  profileType: ProfileType = ProfileType.FPLUS;

  @ViewChild('expandNav', { static: false })
  expandNav: ExpandComponent;

  activeMenuItemTitle$: Observable<string>;
  menuItems$: Observable<MenuItemWithChildren[]>;

  constructor(private loyaltyNavigationService: LoyaltyNavigationService) {}

  ngOnInit(): void {
    if (this.profileType !== ProfileType.CORPORATE && this.profileType !== ProfileType.FINNAIR_ACCOUNT) {
      this.menuItems$ = this.loyaltyNavigationService.getMenuItemsForProfileType(this.profileType);
    }
    this.activeMenuItemTitle$ = this.loyaltyNavigationService.getActiveMenuItemTitle(this.menuItems$);
  }

  toggleDetails(external: boolean): void {
    if (!external && this.expandNav) {
      this.expandNav.toggleDetails();
    }
  }
}
